export default __webpack_public_path__ + "static/media/450.a97c642b.gif";